module.exports = __webpack_public_path__ + "static/media/sidebar-money.c0c055e8.jpg";